import LinkError from './link-error';

export default LinkError;
